export function removeActionHandlers(handlers) {
	const {length: actionsHandlersCount} = handlers;

	for (let i = 0; i < actionsHandlersCount; i++) handlers[i]();

	return [];
}
